import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClienteIntegracaoErpImportService {
    /** Evento executado após finalizar a importação dos clientes do ERP */
    afterImport = new Subject<void>();

    /** Emite o evento de finalização da importação dos clientes do ERP */
    emitAfterImport() {
        this.afterImport?.next();
    }
}
